import React, {FC} from 'react';
import {DataTextBody} from '../data-text-body/data-text-body.component';
import {ElementWrapper} from '../element-wrapper/element-wrapper.component';

type Props = {
  title: string;
  body: string;
};

export const DataElement: FC<Props> = ({title, body}) => (
  <ElementWrapper title={title}>
    <DataTextBody>{body}</DataTextBody>
  </ElementWrapper>
);
